import { z } from 'zod';
import { EmployeeReportFilterI } from 'types';

export const ageRangeOptions = {
  0: [18, 29],
  1: [30, 50],
  2: [51, 100],
};

/**
 * Esquema de validación para los filtros del reporte de empleados.
 * Incluye campos para búsqueda por nombre, fechas, terminal, departamento,
 * puesto, tipo de puesto, género y rango de edad.
 */
export const employeesReportFilterSchema = z.object({
  payrollNum: z.number().optional(),
  fullName: z.string().optional(),
  departmentId: z.string().optional(),
  jobTitleId: z.string().optional(),
  jobTitleTypeId: z.string().optional(),
  entryDate: z.string().optional(),
  terminalId: z.string().optional(),
  gender: z.string().optional(),
  minAge: z.number().optional(),
  maxAge: z.number().optional(),
  ageRange: z.number().optional(),
});

/**
 * Valores predeterminados para los filtros del reporte de empleados.
 */
export const defaultValue: EmployeeReportFilterI = {
  payrollNum: undefined,
  fullName: '',
  departmentId: undefined,
  jobTitleId: undefined,
  jobTitleTypeId: undefined,
  entryDate: undefined,
  terminalId: undefined,
  gender: undefined,
  minAge: undefined,
  maxAge: undefined,
};
